import * as Pet from '../pet';
import * as Inventory from '.';
import * as Fate from '../fate';
import { SB } from '@play-co/replicant';
import createScheduledActions, {
  extractScheduledActionHandlers,
} from 'src/replicant/config/scheduledActions/createScheduledActions';
import { generateReplicantChatbotPayload } from '../chatbot/messageTemplates';
import { NotificationSettings } from 'src/replicant/chatbot/chatbot.ruleset';
import { Locale } from 'src/replicant/ruleset/locale';
import { getChatbotFlexMessage } from 'src/replicant/chatbot/flex/utils';
import { Feature } from 'src/replicant/analytics';
import { State } from 'src/replicant/State';
import { getChatbotMessageChannel } from 'src/replicant/chatbot/chatbot.getters';
import { deliverChatbotMessage } from '../chatbot/chatbot.util';
import type { SyncActionAPI } from '../utils/types';

export const inventoryScheduledActions = (() => {
  const apiSchema = {
    energyRefilled: SB.object({ locale: SB.tuple(['en', 'ja']) }),
  };

  const actions = createScheduledActions(apiSchema)({
    energyRefilled: (state, { locale }, api) => {
      const { receiveMessages } = state.settings;

      const channel = getChatbotMessageChannel(
        state,
        { name: 'energy' },
        api.date.now(),
      );
      if (!channel || receiveMessages !== NotificationSettings.On) {
        return;
      }

      const payload = generateReplicantChatbotPayload({
        feature: Feature.NOTIFICATION._,
        $subFeature: Feature.NOTIFICATION.ENERGY_FULL,
      });

      const getCurrentEvolution = () => Pet.getters.getCurrentEvolution(state);
      const getPetName = () => Pet.getters.getPetName(state);
      const { points, energy, freeGems, paidGems } =
        Inventory.getters.getCurrencies(state, api.date.now());

      let currentSpecies = getCurrentEvolution()?.species;

      const message = getChatbotFlexMessage({
        template: 'fullenergy',
        payload,
        data: {
          locale,
          species: currentSpecies ?? 'dog',
          petName: getPetName(),
        },
        analyticsUserProperties: {
          coins: points,
          energy,
          freeGems,
          paidGems,
          totalGems: freeGems + paidGems,
        },
      });

      const receiverId = api.getUserID();
      deliverChatbotMessage(state, api, {
        receiverId,
        message,
        channel,
      });
    },
  });

  return {
    schema: apiSchema,
    actions: extractScheduledActionHandlers(actions),
  };
})();

export function scheduleEnergyRefilledMessage(
  state: State,
  timeToFullEnergy: number,
  locale: Locale,
  api: Pick<SyncActionAPI, 'date' | 'scheduledActions'>,
) {
  // Get delay, moving message to the morning if pet's sleeping.
  const delayInMS = Fate.getters.getSafeDelay(
    state,
    api.date.now(),
    timeToFullEnergy,
  );

  // Otherwise schedule it.
  api.scheduledActions.schedule.energyRefilled({
    args: { locale },
    notificationId: 'energyRefilled',
    delayInMS,
  });
}
